module.exports = __webpack_public_path__ + "static/media/DSC_0037.2f58afee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0037.jpg
// module id = 679
// module chunks = 0